/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Alert = styled.div`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: ${Palette.Red._500} !important;
  text-align: center;
  color: #fff !important;
  text-align: center;
  border: 1px solid #fff !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;

export const ContainerBtn = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
